export default {
    props: {
        show: Boolean
    },
    name: 'RestrictedPermission',
    methods: {
        goToContactUs() {
            this.$router.push({ name: 'ContactUs' });
        }
    }
};
